<template>
  <div v-show="ticketAccess.permissions.create">
    <div class="d-flex" v-if="!ticketAccess.closed && !ticketAccess.deleted">
      <v-btn
        @click="showReplySection('ticket_reply')"
        color="black"
        class="mr-2 my-1 font-weight-bold"
        id="reply_btn"
        :disabled="supportEmailList.length == 0 || ticketAccess.contactRemoved"
        v-track="'reply-ticket-btn'"
      >
      <v-icon class="white--text pr-1"> mdi-arrow-left-top </v-icon>
      <span class="ml-1 white--text"> Reply </span>
      </v-btn>
      <v-btn
        @click="showReplySection('forward')"
        outlined
        :disabled="supportEmailList.length == 0 || ticketAccess.contactRemoved"
        v-track="'forward-ticket-btn'"
        class="mx-2 my-1 font-weight-bold"
      >
        <v-icon class="pr-1" color="#000"> mdi-arrow-right-top </v-icon>
        Forward
      </v-btn>
      <v-btn
        @click="showReplySection('note')"
        outlined
        class="mx-2 my-1 font-weight-bold"
        v-track="'add-internal-note-btn'"
      >
      <v-icon class="pr-1" color="#000"> mdi-note-plus-outline </v-icon>
        NOTE
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reply-buttons",
  props: {
    ticketDetails: {
      type:[Object, Array],
      default: ()=> ({})
    },
    ticketAccess: {
      type: Object,
    },
    supportEmailList: [Object, Array],
   
  },
  methods: {
    showReplySection(type){
      this.$emit("show-replysection",type)
    }
  }
}
</script>
